__turbopack_context__.v({
  "appCaption": "HvEt7a_appCaption",
  "appImage": "HvEt7a_appImage",
  "appItem": "HvEt7a_appItem",
  "applicationsGrid": "HvEt7a_applicationsGrid",
  "applicationsHeader": "HvEt7a_applicationsHeader",
  "applicationsSection": "HvEt7a_applicationsSection",
  "colorContent": "HvEt7a_colorContent",
  "colorIntro": "HvEt7a_colorIntro",
  "colorSection": "HvEt7a_colorSection",
  "hero": "HvEt7a_hero",
  "maritimeGrid": "HvEt7a_maritimeGrid",
  "metaBlock": "HvEt7a_metaBlock",
  "metaGrid": "HvEt7a_metaGrid",
  "metaLabel": "HvEt7a_metaLabel",
  "metaLeft": "HvEt7a_metaLeft",
  "metaOverview": "HvEt7a_metaOverview",
  "metaRight": "HvEt7a_metaRight",
  "metaSection": "HvEt7a_metaSection",
  "metaText": "HvEt7a_metaText",
  "metaTools": "HvEt7a_metaTools",
  "outcomesSection": "HvEt7a_outcomesSection",
  "page": "HvEt7a_page",
  "processSection": "HvEt7a_processSection",
  "resultDetail": "HvEt7a_resultDetail",
  "resultItem": "HvEt7a_resultItem",
  "resultLabel": "HvEt7a_resultLabel",
  "resultValue": "HvEt7a_resultValue",
  "resultsContent": "HvEt7a_resultsContent",
  "resultsGrid": "HvEt7a_resultsGrid",
  "resultsSection": "HvEt7a_resultsSection",
  "storySection": "HvEt7a_storySection",
  "teamAvatar": "HvEt7a_teamAvatar",
  "teamAvatarPlaceholder": "HvEt7a_teamAvatarPlaceholder",
  "teamContent": "HvEt7a_teamContent",
  "teamGrid": "HvEt7a_teamGrid",
  "teamMember": "HvEt7a_teamMember",
  "teamName": "HvEt7a_teamName",
  "teamRole": "HvEt7a_teamRole",
  "teamSection": "HvEt7a_teamSection",
  "typographyContent": "HvEt7a_typographyContent",
  "typographyIntro": "HvEt7a_typographyIntro",
  "typographyNote": "HvEt7a_typographyNote",
  "typographySection": "HvEt7a_typographySection",
  "typographyWaterfall": "HvEt7a_typographyWaterfall",
  "waterfallBody": "HvEt7a_waterfallBody",
  "waterfallCaption": "HvEt7a_waterfallCaption",
  "waterfallHeader": "HvEt7a_waterfallHeader",
  "waterfallItem": "HvEt7a_waterfallItem",
  "waterfallLabel": "HvEt7a_waterfallLabel",
  "waterfallSubhead": "HvEt7a_waterfallSubhead",
});
